import type { ServiceOfferDto } from "@/app/types/serviceOffers";

function toIso(value: Date | string | null | undefined): string | null {
  if (!value) return null;
  if (typeof value === "string") return value;
  return value.toISOString();
}

export function mapServiceOfferListResponse(input: unknown): ServiceOfferDto[] {
  if (!Array.isArray(input)) return [];
  return input as ServiceOfferDto[];
}

export function mapServiceOfferDetailResponse(input: unknown) {
  if (!input || typeof input !== "object") return null;
  const offer = input as ServiceOfferDto;
  return {
    ...offer,
    durationMinutes: offer.defaultDurationMin ?? null,
    eventNumber: offer.eventNumber ?? null,
    series: Array.isArray(offer.series)
      ? offer.series.map((series) => ({
          id: series.id,
          name: series.name,
          startDate: series.startDate,
          endDate: series.endDate,
          eventsCount: series.eventsCount ?? 0,
          events: [],
          bookingsCount: series.bookingsCount ?? 0,
          bookingsMin: series.bookingsMin ?? null,
          bookingsMax: series.bookingsMax ?? null,
          eventNumber: series.eventNumber ?? null,
        }))
      : [],
  };
}

export function mapServiceSeriesDetailResponse(input: unknown) {
  if (!input || typeof input !== "object") return null;
  const payload = input as {
    id: number;
    offerId?: number;
    courseId?: number;
    offerName?: string;
    courseName?: string;
    name?: string;
    startDate?: string | null;
    endDate?: string | null;
    status?: string;
    defaultDurationMin?: number | null;
    eventNumber?: number | null;
    bookingsMin?: number | null;
    bookingsMax?: number | null;
    occurrences?: Array<{ id: number; startAt: string | Date; endAt: string | Date }>;
    events?: Array<{ id: number; start: string | Date; end: string | Date }>;
  };

  return {
    id: payload.id,
    courseId: payload.offerId ?? payload.courseId ?? null,
    courseName: payload.offerName ?? payload.courseName ?? null,
    name: payload.name ?? "",
    startDate: payload.startDate ?? null,
    endDate: payload.endDate ?? null,
    active: payload.status === "active",
    eventNumber: payload.eventNumber ?? null,
    defaultDurationMin: payload.defaultDurationMin ?? null,
    bookingsMin: payload.bookingsMin ?? null,
    bookingsMax: payload.bookingsMax ?? null,
    events: Array.isArray(payload.events)
      ? payload.events.map((event) => ({
          id: event.id,
          start: toIso(event.start),
          end: toIso(event.end),
          title: null,
        }))
      : Array.isArray(payload.occurrences)
      ? payload.occurrences.map((occurrence) => ({
          id: occurrence.id,
          start: toIso(occurrence.startAt),
          end: toIso(occurrence.endAt),
          title: null,
        }))
      : [],
  };
}

export function mapServiceSeriesBookingsResponse(input: unknown) {
  if (!input || typeof input !== "object") return [];
  const root = input as { bookings?: unknown[] };
  if (!Array.isArray(root.bookings)) return [];
  return root.bookings;
}

export function mapServiceBookingDetailResponse(input: unknown) {
  if (!input || typeof input !== "object") return null;
  return input;
}
